import React from 'react';
import styled from 'styled-components';
import { BodyText } from '@grnhse/seedling/lib/azalea/typography';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import { Arrow } from '@grnhse/seedling/lib/azalea/icons';
import { withLocalePrefix } from 'shared/utils/translation';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { TertiaryButton } from '@grnhse/bonsai/lib/components/buttons';
import { useBonsai } from '@grnhse/bonsai/lib/hooks';

const t = withLocalePrefix('self_schedule.candidate_view');

type Props = {
  page?: number;
  goBack: () => void;
  bonsaiEnabled: boolean;
};

const BackButton = (props: Props) => {
  const { linkColor } = useBonsai();

  if (props.page === 0 || props.page === undefined) {
    return null;
  }

  if (props.bonsaiEnabled) {
    return (
      <div style={{ marginTop: '20px' }}>
        <TertiaryButton ariaLabel={t('back')} onClick={props.goBack}>
          <BackArrow color={linkColor} height={12} />
          {t('back')}
        </TertiaryButton>
      </div>
    );
  }

  return (
    <StyledButton
      onClick={props.goBack}
      block={false}
      hideBg
      removeHideBgPadding
      useButtonTag
    >
      <BackArrow color={FullPalette.GREEN_700} height={12} />
      <Text>{t('back')}</Text>
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  position: absolute;
  top: 20px;

  &:hover {
    text-decoration: none;
  }

  @media only screen and (max-width: 1024px) {
    top: -10px;
  }
`;

const BackArrow = styled(Arrow)`
  transform: rotate(270deg);
`;

const Text = styled(BodyText)`
  color: ${FullPalette.GREEN_700};
`;

export default BackButton;
